import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";
import "./galleryPage.css";

export default function GalleryPage() {
  const [images, setImages] = useState([]);
  const [visibleCount, setVisibleCount] = useState(20);
  const [selected, setSelected] = useState(null);

  const navigate = useNavigate();

  // 🔥 LOAD DATA
  useEffect(() => {

    // CACHE FIRST (instant)
    const cached = localStorage.getItem("galleryData");
    if (cached) {
      try {
        setImages(JSON.parse(cached));
      } catch {}
    }

    // FIRESTORE REALTIME
    const ref = doc(db, "siteContent", "gallery");

    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        const data = snap.data().items || [];
        setImages(data);
        localStorage.setItem("galleryData", JSON.stringify(data));
      }
    });

    return () => unsub();
  }, []);

  // 🔥 PAGINATION
  const visibleImages = images.slice(0, visibleCount);

  return (
    <section className="gallery-page">

      {/* BACK */}
      <div className="gallery-topbar">
        <button className="back-btn" onClick={() => navigate("/")}>
          ← Back
        </button>
      </div>

      {/* HEADER */}
      <div className="gallery-header">
        <h1>Gallery Collection</h1>
        <p>Moments from academic excellence, research, and achievements</p>
      </div>

      {/* GRID */}
      <div className="gallery-page-grid">
        {visibleImages.map((img, i) => (
          <div
            key={i}
            className="gallery-page-item"
            onClick={() => setSelected(img)}
          >
            <img src={img.src} alt={img.title} />

            <div className="overlay">
              <span className="category">{img.category || "Gallery"}</span>
              <h4>{img.title}</h4>
            </div>
          </div>
        ))}
      </div>

      {/* 🔥 LOAD MORE BUTTON */}
      {visibleCount < images.length && (
        <div className="load-more-wrapper">
          <button
            className="load-more-btn"
            onClick={() => setVisibleCount(prev => prev + 20)}
          >
            Load More ↓
          </button>
        </div>
      )}

      {/* LIGHTBOX */}
      {selected && (
        <div className="lightbox" onClick={() => setSelected(null)}>
          <div
            className="lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={selected.src} alt={selected.title} />
            <h3>{selected.title}</h3>
            <p>{selected.category}</p>
          </div>
        </div>
      )}

    </section>
  );
}